import { CampaignDataT, ProjectT } from "../../models/models";

export enum WizardModeE {
    Create = 'create',
    Edit = 'edit',
    Clone = 'clone',
};

export enum WizardTypeE {
    Campaign = 'campaign',
    Delivery = 'delivery',
};

export type CreateWizardPropsT = {
    defaultCampaignData?: ProjectT;
    defaultDeliveryData?: ProjectT;
    type: WizardTypeE;
    mode: WizardModeE;
    deliveryId?: number;
    campaignDeliveryId?: number;
};